import { createContentfulClient } from "./createContentfulClient"

export type postMetaType = {
  postTitle: string
  postUrl: string
}

type slugProp = string | string[] | undefined

export const getBlogsMeta = async (slug?: slugProp) => {
  const client = createContentfulClient()

  let skip = 0
  let postCollectionMeta: postMetaType[] = []
  let total: number

  do {
    const query: Record<string, unknown> = {
      content_type: 'blogPost',
      skip,
      limit: 100,
    }

    if (slug) {
      query['fields.postUrl'] = slug
    }

    const post = await client.getEntries(query)

    if (post.items.length < 1) {
      return {
        notFound: true,
      }
    }

    total = post.total

    for (let i = 0; i < post.items.length; i++) {
      const postTitle = (post.items as any[])[i].fields.postTitle
      const postUrl = (post.items as any[])[i].fields.postUrl
      postCollectionMeta.push({ postTitle, postUrl })
    }

    skip += 100
  } while (skip < total)

    return postCollectionMeta
}
